export const DEFAULT_CMS_LOCALE = 'me';
export const ENGLISH_CMS_LOCALE = 'en';

export const SUPPORTED_CMS_LOCALES = [DEFAULT_CMS_LOCALE, ENGLISH_CMS_LOCALE];

export const getCmsLocaleFromLanguage = (language = DEFAULT_CMS_LOCALE) => {
  const normalized = String(language || DEFAULT_CMS_LOCALE).trim().toLowerCase();

  if (normalized.startsWith('en')) return ENGLISH_CMS_LOCALE;
  return DEFAULT_CMS_LOCALE;
};

export const isEnglishCmsLocale = (language = DEFAULT_CMS_LOCALE) => {
  return getCmsLocaleFromLanguage(language) === ENGLISH_CMS_LOCALE;
};

export const hasEnglishCmsVersion = (resource = {}) => {
  if (!resource) return false;

  if (typeof resource?.hasEnglishContent === 'boolean') return resource.hasEnglishContent;
  if (resource?.locale?.readiness?.en === 'ready') return true;
  if (resource?.locale?.readiness?.en === 'missing') return false;
  if (resource?.translations?.en === true) return true;
  if (resource?.locale?.available?.en === true) return true;

  const nested = resource?.cms;
  if (nested && nested !== resource) return hasEnglishCmsVersion(nested);

  return false;
};

export const isEnglishFallbackContent = (resource = {}, language = DEFAULT_CMS_LOCALE) => {
  return isEnglishCmsLocale(language) && !hasEnglishCmsVersion(resource);
};
